export const launchDuration = 3600
export const quoteDuration = 1400
export const pageTransitionDuration = 400

export const onboardingSteps = {
  video1: { src: '/assets/onboarding/onb-intro.mp4', poster: '/assets/onboarding/onb-intro.jpg', fullScreen: false },
  video3: { src: '/assets/onboarding/onb_new.mp4', poster: '/assets/onboarding/onb_new.jpg', fullScreen: true },
} as const

export type VideoStep = keyof typeof onboardingSteps
export const onboardingVideoOrder: VideoStep[] = ['video1', 'video3']
